import * as paymentOptionsMetadataTypes from 'commons-vehicle/PaymentOptionsMetadata/actions/paymentOptionsMetadataActionTypes.js';

export default function paymentOptionsMetadata(state = [], action) {
    switch (action.type) {
        case paymentOptionsMetadataTypes.LOAD_PAYMENT_OPTIONS_METADATA_SUCCESS:
            return action.paymentOptionsMetadata;

        default:
            return state;
    }
}
